// extracted by mini-css-extract-plugin
module.exports = {"section":"Steps_section__cQRgN","step":"Steps_step__3hBLa","number":"Steps_number__3jQFL","content":"Steps_content__2-gUm","wrap":"Steps_wrap__YZlPz","title":"Steps_title__2ccgU"};